// Create empty block item based on block type
export const createEmptyBlockItem = (blockType, defaults = {}) => {
    switch (blockType) {
        case "Text":
            return { text: "" };
        case "Bullet list":
            return { item: "", prefixType: defaults.prefixType || "" };
        case "Card grid":
            return {
                blockTitle: "",
                iconColor: defaults.iconColor || "",
                iconType: defaults.iconType || "",
                value: "",
            };
        case "Progress bar":
            return { label: "", barColor: defaults.barColor || "", value: 50 };
        case "Metrics":
            return {
                metricTitle: "",
                prefix: defaults.metricPrefix || "",
                value: "",
                suffix: defaults.metricSuffix || "",
            };
        case "Status":
            return { statusTitle: "", description: "", status: defaults.status || "" };
        case "Upload documents":
            return { fileName: "", fileUrl: "", fileType: "" };
        default:
            return {};
    }
};

// Resolve color code from API options list
export const getColorHex = (colorValue, colorOptions = []) => {
    const selected = colorOptions.find((opt) => opt.optionValue === colorValue);
    return selected?.colorCode || "currentColor";
};

export const resolveColor = (value, colorOptions = []) => {
    if (!value) return "currentColor";
    if (String(value).startsWith("#")) return value;
    const mappedColor = getColorHex(value, colorOptions);
    // If mapping not found, getColorHex returns 'currentColor' which should be used as fallback.
    return mappedColor;
};

export const SYMBOL_MAP = {
    dot: "•",
    circle: "○",
    square: "■",
};
